import { HttpClient, HttpParams } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { saveAs } from 'file-saver';

@Component({
    selector: 'pcg-download-button',
    templateUrl: './download-button.component.html',
    styleUrls: ['./download-button.component.scss'],
    standalone: false
})
export class DownloadButtonComponent implements OnInit {
	//Relative path to the image for the icon
	@Input() imgUrl: string = "../../../../assets/images/actions/attachment.svg";
	@Input() apiUrl: string;
	@Input() fileType: string;
	@Input() fileName: string;
	@Input() recordId: number;

	constructor(private httpClient: HttpClient) { }

	ngOnInit() {
	}

	getFile() {
		let params = new HttpParams()
			.set('fileName', this.fileName)
			.set('id', this.recordId.toString());

		this.httpClient
			.get(this.apiUrl, { params: params, responseType: 'blob' })
			.subscribe(blob => {
				saveAs(blob, this.fileName);
			})
	}
}
